<template>
	<div class="main-table">
		<div class="main-table-box">
			<el-table
				class="grid-content"
				:data="tableData"
				border
				stripe
				@row-dblclick='rowClick'
				:height="tableHeight"
				@sort-change='sortChangeHandle'
				@selection-change="selectionChangeHandle"
			>
				<el-table-column
					type="selection"
					align="center"
					width="50">
				</el-table-column>
				<el-table-column
					prop="customerName"
					label="客户名称"
					align="center">
				</el-table-column>
				<el-table-column
					prop="customerCode"
					label="客户编号"
					align="center">
				</el-table-column>
				<el-table-column
					prop="disabledflag"
					label="客户状态"
					align="center">
					<template slot-scope="scope">
						<div class="history-status" v-if="!scope.row.disabledflag"><span></span>启用中</div>
						<div class="history-status" v-else><span style="background:#ED4F31"></span>停用中</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="customerlevelname"
					label="客户等级"
					align="center">
				</el-table-column>
				<el-table-column
					prop="customerCategoryName"
					label="客户类别"
					align="center">
				</el-table-column>
				<el-table-column
					prop="usablepremoney"
					label="可用预付货款"
					:sortable="prepaymentdefaultaccount !== 0 ? 'custom' : true"
					align="center"
					width="180">
					<template slot="header">
						<div style="display:inline-block;">可用预付货款
							<el-tooltip class="item" effect="light" placement="top-start">
								<div slot="content">
									1）当前买家账户可以提交订单的<br>金额！<br>
									2）已用预付货款金额是买家已提<br>单花费的预付货款金额！
								</div>
								<img src="~/images/icon/tooltip-icon.png" style="display:inline-block;">
							</el-tooltip>
						</div>
					</template>
					<template slot-scope="scope">
						<div>
							￥{{scope.row.usablepremoney}}
							<i class="el-icon-refresh" v-if="prepaymentdefaultaccount === 0 && !scope.row.refreshing" @click="refreshMoney(scope.row, scope.$index)" style="color:var(--fx-primary-color);margin-left:5px;cursor:pointer;"></i>
							<i class="el-icon-loading" v-if="prepaymentdefaultaccount === 0 && scope.row.refreshing" style="color:var(--fx-primary-color);"></i>
						</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="premoney"
					label="预付货款总计"
					:sortable="prepaymentdefaultaccount !== 0 ? 'custom' : true"
					align="center"
					width="180">
					<template slot="header">
						<div style="display:inline-block;">预付货款总计
							<el-tooltip class="item" effect="light" content="当前买家账户向卖家充值的所有预付货款金额的合计！" placement="top-start">
								<img src="~/images/icon/tooltip-icon.png" style="display:inline-block;">
							</el-tooltip>
						</div>
					</template>
					<template slot-scope="scope">
						<div>￥{{scope.row.premoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="usAbleCostPreMoney"
					v-if="showgift === 1"
					label="可用充值金额"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.usAbleCostPreMoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="usAbleGiftPreMoney"
					label="可用赠送金额"
					v-if="showgift === 1"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.usAbleGiftPreMoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="costPreMoney"
					label="充值金额统计"
					v-if="showgift === 1"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.costPreMoney}}</div>
					</template>
				</el-table-column>
				<el-table-column
					prop="giftPreMoney"
					label="赠送金额统计"
					v-if="showgift === 1"
					align="center">
					<template slot-scope="scope">
						<div>￥{{scope.row.giftPreMoney}}</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="220" align="center">
					<template slot-scope="scope">
						<el-button type='text' size="mini" @click="getDetail(scope.row, 3)" v-if="AuthorityList['04_0002_0001_00'] || AuthorityList['04_0002_0002_00']">查看明细</el-button>
						<el-button type='text' size="mini" @click="rechargeItem(scope.row)" v-if="AuthorityList['04_0002_0002_00']">充值</el-button>
						<el-button type='text' size="mini" @click="decreaseItem(scope.row)" v-if="AuthorityList['04_0002_0002_00']">扣减</el-button>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="page-box">
			<div class="sum-box">合计
				<el-tooltip class="item" effect="dark" placement="top-start" popper-class="sum-pop">
					<div slot="content">
						<div class="sum-popcontent">
							<div>
								<div>名称</div>
								<div>可用预付货款</div>
								<div>预付货款总计</div>
								<div v-if="showgift === 1">
									<div>可用充值金额</div>
									<div>可用赠送金额</div>
									<div>充值金额总计</div>
									<div>赠送金额总计</div>
								</div>
							</div>
							<div v-if="prepaymentdefaultaccount !== 1">
								<div>总计</div>
								<div>{{sumData.sumUsablePreMoney}}</div>
								<div>{{sumData.sumPreMoney}}</div>
								<div v-if="showgift === 1">
									<div>{{sumData.sumUsableCostPreMoney}}</div>
									<div>{{sumData.sumUsableGiftPreMoney}}</div>
									<div>{{sumData.sumCostPreMoney}}</div>
									<div>{{sumData.sumGiftPreMoney}}</div>
								</div>
							</div>
							<div>
								<div>已选中</div>
								<div>{{calcSumData.usablepremoney}}</div>
								<div>{{calcSumData.premoney}}</div>
								<div v-if="showgift === 1">
									<div>{{calcSumData.usAbleCostPreMoney}}</div>
									<div>{{calcSumData.usAbleGiftPreMoney}}</div>
									<div>{{calcSumData.costPreMoney}}</div>
									<div>{{calcSumData.giftPreMoney}}</div>
								</div>
							</div>
						</div>
					</div>
					<img src="~/images/icon/tooltip-icon.png" class="sum-tip">
				</el-tooltip>
			</div>
			<el-pagination
				v-if="prepaymentdefaultaccount !== 0"
				@size-change="handleSizeChange"
				@current-change="handlePageChange"
				:current-page="pagination.page"
				:page-sizes="[20,40, 60, 100]"
				:page-size="pagination.size"
				layout="total, sizes, prev, pager, next, jumper"
				:total="totalCount">
			</el-pagination>
		</div>
		<el-dialog
			title="充值预付货款"
			:visible.sync="dialogVisible"
			class="dialog-title"
			width="650px"
			:close-on-click-modal="false">
			<div>
				<div class="dialog-charge-content">
					<div>
						<span class="dialog-name">充值客户：</span>
						<span>{{rechargeRow.customerName}}</span>
					</div>
					<div>
						<span class="dialog-name">充值方式：</span>
						<div class="dialog-readonly">线下支付</div>
					</div>
					<div>
						<span class="dialog-name">充值金额：</span>
						<div class="per-money">
							<span class="per-tag">￥</span>
							<el-input class="per-input" v-model="percentValue" @input="percentInput" size="small"></el-input>
						</div>
						<el-tooltip class="item" effect="light" content="当前买家账户向卖家充值的货款金额！" placement="top-start">
							<img src="~/images/icon/tooltip-icon.png" style="cursor:pointer;">
						</el-tooltip>
					</div>
					<div v-if="showgift === 1">
						<span class="dialog-name">赠送金额：</span>
						<div class="per-money">
							<span class="per-tag">￥</span>
							<el-input class="per-input" v-model="giftMoney" @input="giftMoneyInput" size="small"></el-input>
						</div>
					</div>
					<div style="align-items: start;">
						<span class="dialog-name">备注：</span>
						<div>
							<el-input type="textarea" size="mini" maxlength="300" style="width:265px" v-model="remarks2"></el-input>
						</div>
					</div>
					<div style="display: flex;flex-flow: row;flex-wrap: wrap;height: 60px;" v-if="showgift === 1">
						<div>
							<span class="dialog-name" style="width:156px;">可用【充值】金额：</span>
							<span>¥{{rechargeRow.usAbleCostPreMoney}}</span>
						</div>
						<div style="margin-left:20px;" v-if="showgift === 1">
							<span class="dialog-name" style="width:156px;">可用【赠送】金额：</span>
							<span>¥{{rechargeRow.usAbleGiftPreMoney}}</span>
						</div>
					</div>
					<div v-if="showgift === 0">
						<span class="dialog-name">可用预付货款：</span>
						<span>{{rechargeRow.usablepremoney}}</span>
					</div>
					<span class="dialog-name">上传附件：</span>最多2张，小于1M/张，推荐图片比例 1:1， 格式：png / jpg / jpeg / gif
					<div style="align-items: start;margin: 30px;">
						<div>
							<div>
								<ImgUpload
									class="show-img"
									v-for="(item, index) in showSrc"
									:key="index"
									:imgSrc.sync="item.img"
									:extension.sync="item.extension"
									:imgId.sync="item.id"
									:location="index"
									@deletImg="deletImg"
									@uploadNewImg="uploadNewImg"
									@preview2="preview2"
									ref="showUpload"
								/>
								<ImgUpload2
									class="show-img"
									v-if="showSrc.length < 2"
									@uploadNewImg="uploadNewImg"
									ref="showUpload2"
								/>
							</div>
							<!-- <div style="clear:left">最多2张，小于1M/张，推荐图片比例1：1<br>格式：png / jpg / jpeg / gif</div> -->
						</div>
					</div>
				</div>
				<div style="text-align:right">
					<el-button class="btn" size="small" plain @click="close">取消</el-button>
					<el-button class="btn" size="small" type="primary" @click="itemRecharge">确定</el-button>
				</div>
			</div>
		</el-dialog>
		<el-dialog
			title="附件"
			:visible.sync="picVisible"
			:close-on-click-modal="false"
			class="dialog-title"
			width="700px">
			<div class="preview-box"><w-image :src="previewSrc" alt="" width="400" height="400"></w-image></div>
		</el-dialog>
		<el-dialog
			title="预付货款账户切换提示"
			:visible.sync="tipModel"
			class="tip-modal"
			:close-on-click-modal="false"
			width="500px">
			<div style="display:flex;flex-direction: column;text-align: left;">
				<div class="title">{{handleType}}功能已停用</div>
				<div class="content">1、当前预付货款数据来源为：云供应链</div>
				<div class="content"> 2、为了保证数据准确，请前往‘云供应链’系统进行{{handleType}}操作</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button size="mini" @click="cancelClick">已了解</el-button>
			</span>
		</el-dialog>
		<el-dialog
			title="扣减预付货款"
			:visible.sync="decreaseDialogVisible"
			class="dialog-title"
			width="500px"
			:close-on-click-modal="false">
			<div>
				<div class="dialog-charge-content">
					<div>
						<span class="dialog-name">充值客户：</span>
						<span>{{decreaseRow.customerName}}</span>
					</div>
					<div>
						<span class="dialog-name">充值方式：</span>
						<div class="dialog-readonly">手工扣减</div>
					</div>
					<div>
						<span class="dialog-name">扣减<span v-if="showgift === 1">本金</span>金额：</span>
						<div class="per-money">
							<span class="per-tag">-￥</span>
							<el-input class="per-input" v-model="decreasePercentValue" @input="decreasePercentInput" size="small"></el-input>
						</div>
					</div>
					<div v-if="showgift === 1">
						<span class="dialog-name">扣减赠送金额：</span>
						<div class="per-money">
							<span class="per-tag">-￥</span>
							<el-input class="per-input" v-model="decreaseGiftMoney" @input="decreaseGiftMoneyInput" size="small"></el-input>
						</div>
					</div>
					<div style="align-items: start;">
						<span class="dialog-name">备注：</span>
						<div>
							<el-input type="textarea" size="mini" maxlength="300" style="width:263px" v-model="remarks"></el-input>
						</div>
					</div>
					<div style="display: flex;flex-flow: row;flex-wrap: wrap;height: 60px;" v-if="showgift === 1">
						<div style="padding-right:40px;">
							<span class="dialog-name" style="width: 130px;text-align: left;">可用【充值】金额：</span>
							<span>¥{{decreaseRow.usAbleCostPreMoney}}</span>
						</div>
						<div v-if="showgift === 1">
							<span class="dialog-name" style="width: 130px;text-align: left;">可用【赠送】金额：</span>
							<span>¥{{decreaseRow.usAbleGiftPreMoney}}</span>
						</div>
					</div>
					<div v-if="showgift === 0">
						<span class="dialog-name">可用预付货款：</span>
						<span>{{decreaseRow.usablepremoney}}</span>
					</div>
					<div style="align-items: start;color: red;">
						温馨提示：<br/>
						1.进行金额扣减时，仅对客户账户余额进行扣减，实际发生的充值金额系统不会返回，请卖家谨慎操作！<br/>
						2.当客户预付货款含赠送金额时，订单扣减充值金额及赠送金额的比例不包含已扣减的金额！
					</div>
				</div>
				<div style="text-align:right">
					<el-button class="btn" size="small" plain @click="closeDecrease">取消</el-button>
					<el-button class="btn" size="small" type="primary" @click="itemDecrease">确定</el-button>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import ImgUpload from '@/components/payAdvance/ImgUpload.vue'
import ImgUpload2 from '@/components/payAdvance/ImgUpload2.vue'
export default {
	name: 'mainTable',
	components: {
		ImgUpload,
		ImgUpload2
	},
	props: {
		tableData: {
			type: Array
		},
		totalCount: {
			type: Number
		},
		size: {
			type: Number,
			default: 20
		},
		page: {
			type: Number,
			default: 1
		},
		AuthorityList: {
			type: Object
		},
		sumData: {
			type: Object
		},
		needauditingflag: Boolean,
		canundeliveredunpaysendflag: Boolean,
		prepaymentdefaultaccount: {
			type: Number,
			default: 0
		},
		showgift: {
			type: Number,
			default: 1
		}
	},
	data () {
		return {
			tableHeight: '100%',
			pagination: {
				page: this.page,
				size: this.size
			},
			dialogVisible: false,
			percentValue: '',
			giftMoney: '',
			ids: [],
			showSrc: [],
			rechargeRow: {},
			decreaseRow: {},
			previewSrc: '',
			picVisible: false,
			tipModel: false,
			decreaseDialogVisible: false,
			decreasePercentValue: '',
			decreaseGiftMoney: '',
			handleType: '',
			calcSumData: {
				usablepremoney: '0.00',
				premoney: '0.00',
				usAbleCostPreMoney: '0.00',
				usAbleGiftPreMoney: '0.00',
				costPreMoney: '0.00',
				giftPreMoney: '0.00'
			},
			remarks: '',
			remarks2: ''
		}
	},
	created () {
		// this.getAuthority('07_0001_0000_00')
		// this.checkSmallCategory()
	},
	methods: {
		cancelClick () {
			this.tipModel = false
		},
		rowClick (row, column, event) {
			if (this.AuthorityList['04_0002_0001_00'] || this.AuthorityList['04_0002_0002_00']) {
				this.getDetail(row)
			}
		},
		refreshMoney (row, index) {
			this.$emit('refreshMoney', row, index)
		},
		percentInput () {
			this.percentValue = this.percentValue.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.percentValue = this.percentValue.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.percentValue = this.percentValue.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			if (+this.percentValue >= 10000000) {
				this.percentValue = this.percentValue.substring(0, 7)
			} else {
				this.percentValue = this.percentValue.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
			}
		},
		decreasePercentInput () {
			this.decreasePercentValue = this.decreasePercentValue.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.decreasePercentValue = this.decreasePercentValue.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.decreasePercentValue = this.decreasePercentValue.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			if (+this.decreasePercentValue >= 10000000) {
				this.decreasePercentValue = this.decreasePercentValue.substring(0, 7)
			} else {
				this.decreasePercentValue = this.decreasePercentValue.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
			}
		},
		decreaseGiftMoneyInput () {
			this.decreaseGiftMoney = this.decreaseGiftMoney.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.decreaseGiftMoney = this.decreaseGiftMoney.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.decreaseGiftMoney = this.decreaseGiftMoney.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			if (+this.decreaseGiftMoney >= 10000000) {
				this.decreaseGiftMoney = this.decreaseGiftMoney.substring(0, 7)
			} else {
				this.decreaseGiftMoney = this.decreaseGiftMoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
			}
		},
		giftMoneyInput () {
			this.giftMoney = this.giftMoney.replace(/[^\d.]/g, '')// 清除"数字"和"."以外的字符
			this.giftMoney = this.giftMoney.replace(/^\./g, '')// 验证第一个字符是数字而不是
			this.giftMoney = this.giftMoney.replace(/\.{2,}/g, '.')// 只保留第一个. 清除多余的
			if (+this.giftMoney >= 10000000) {
				this.giftMoney = this.giftMoney.substring(0, 7)
			} else {
				this.giftMoney = this.giftMoney.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')
			}
		},
		selectionChangeHandle (value) {
			let ids = value.map(item => {
				return item.customerid
			})
			this.ids = ids
			this.$emit('selectIds', ids)
			this.getCalcSumData()
		},
		getCalcSumData () {
			this.calcSumData = {
				usablepremoney: '0.00',
				premoney: '0.00',
				usAbleCostPreMoney: '0.00',
				usAbleGiftPreMoney: '0.00',
				costPreMoney: '0.00',
				giftPreMoney: '0.00'
			}
			this.tableData.forEach(item => {
				if (this.ids.indexOf(item.customerid) !== -1) {
					for (let key in this.calcSumData) {
						this.calcSumData[key] = this.$fxUtils.toFixedSHW(+this.calcSumData[key] + (+item[key]), 2)
					}
				}
			})
		},
		sortChangeHandle (data) {
			// console.log(data)
			if (this.prepaymentdefaultaccount !== 0) {
				if (data.order === null) {
					this.$emit('sortSearch', { orderKey: '', orderBy: '' })
				} else {
					let orderBy = data.order === 'descending' ? 1 : 0
					this.$emit('sortSearch', { orderKey: data.prop, orderBy: orderBy })
				}
			}
		},
		getDetail (value) {
			// window.sessionStorage.setItem('percentageId', value.planid)
			this.$router.push({ path: '/main/advanceDetail', query: { customerid: value.customerid, name: value.customerName } })
		},
		rechargeItem (row) {
			this.handleType = '充值'
			if (this.prepaymentdefaultaccount !== 0) {
				this.tipModel = true
				return false
			}
			this.rechargeRow = row
			this.dialogVisible = true
		},
		close () {
			this.dialogVisible = false
		},
		uploadNewImg (oldUrl, index, id) {
			index = index === undefined ? this.showSrc.length : index
			let needUrl = `${this.$fxBaseApi.urlQIVShop}/upload/pic/tempcompression`
			var formData = new FormData()
			if (oldUrl === '') {
				formData.append('extension', this.$refs.showUpload2.fileFiles.name.split('.')[1])
				formData.append('file', this.$refs.showUpload2.fileFiles)
			} else {
				formData.append('extension', this.$refs.showUpload[index].fileFiles.name.split('.')[1])
				formData.append('file', this.$refs.showUpload[index].fileFiles)
			}
			this.$store.dispatch('requestFilePost', {
				url: needUrl,
				data: formData
			}).then(res => {
				if (res.result) {
					this.$message.success('上传成功')
					let img = { img: res.data }
					if (oldUrl === '') {
						this.showSrc.push(img)
					} else {
						this.showSrc.splice(index, 1, img)
					}
				} else {
					this.$message.error(res.msg)
				}
			}).catch((error) => {
				this.$message.error(error.msg)
			})
		},
		deletImg (id, index, path) {
			index = +index
			this.showSrc.splice(index, 1)
		},
		preview2 (src) {
			// console.log(this.showSrc)
			// this.initialIndex2 = this.showSrc.findIndex(item => {
			// 	return +item.id === +seqnum
			// })
			// console.log(this.initialIndex2)
			// // this.initialIndex2 = index
			// this.sellVoucherImg = this.showSrc.filter(item => {
			// 	return item.url !== ''
			// })
			// console.log(this.sellVoucherImg)
			// let emptyArr = []
			// this.sellVoucherImg = emptyArr.concat(seqnum)
			// console.log(this.sellVoucherImg)
			this.previewSrc = src
			this.picVisible = true
		},
		itemRecharge () {
			if (!this.percentValue) {
				this.$message.error('预付货款金额不可为空！')
				return false
			}
			// if (+this.percentValue === 0) {
			// 	this.$message.error('预付货款金额不可为0！')
			// 	return false
			// }
			const h = this.$createElement
			const that = this
			this.$msgbox({
				title: '确认充值？',
				message: h('div', null, [
					h('div', { style: 'padding-left:20px;font-size: 20px' }, '￥' + that.percentValue),
					h('div', { style: 'padding-left:20px' }, '充值后不可取消或修改')
				]),
				showCancelButton: true,
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let params = {
					money: +this.percentValue,
					giftMoney: +this.giftMoney,
					customerid: this.rechargeRow.customerid,
					imgList: this.showSrc,
					prepaymenttype: 4,
					remarks: this.remarks2
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/order/prepayment/add`,
					data: params
				}).then(res => {
					if (res.result) {
						this.percentValue = ''
						this.giftMoney = ''
						this.remarks2 = ''
						this.showSrc = []
						this.dialogVisible = false
						this.$message.success('充值成功！')
						this.$emit('modifySuc')
					} else {
						if (res.msg === null) {
							this.$message.error('处理失败，请稍后重试！')
						} else {
							this.$message.error(res.msg)
						}
					}
				})
			})
		},
		deleteItem (row) {
			this.$confirm('提成规则删除后不可恢复，是否继续删除？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				closeOnClickModal: false
			}).then(() => {
				let params = {
					commissionPlanIds: row.planid
				}
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/commission/delplan`,
					data: params
				}).then(res => {
					if (res.result) {
						this.$message.success('删除成功')
						this.$emit('modifySuc')
					} else {
						this.$message.error(res.msg)
					}
				}).catch(error => {
					this.$message.error(error.msg)
				})
			}).catch(() => {})
		},
		handleSizeChange (value) {
			this.pagination.size = value
			this.$emit('handleSize', value)
		},
		handlePageChange (value) {
			this.pagination.page = value
			this.$emit('handlePage', value)
		},
		decreaseItem (row) {
			this.handleType = '扣减'
			if (this.prepaymentdefaultaccount !== 0) {
				this.tipModel = true
				return false
			}
			this.decreaseRow = row
			this.decreaseDialogVisible = true
		},
		closeDecrease () {
			this.decreaseDialogVisible = false
		},
		itemDecrease () {
			if (!this.decreasePercentValue) {
				this.$message.error('预付货款扣减金额不能为空')
				return false
			}
			if (+this.decreasePercentValue === 0) {
				this.$message.error('预付货款扣减金额不能为0')
				return false
			}
			if ((+this.decreasePercentValue > +this.decreaseRow.usAbleCostPreMoney) && this.showgift === 1) {
				this.$message.error('当前预付货款不足！')
				return false
			}
			if ((+this.decreasePercentValue > +this.decreaseRow.usablepremoney) && this.showgift === 0) {
				this.$message.error('当前预付货款不足！')
				return false
			}
			if (+this.decreaseGiftMoney > +this.decreaseRow.usAbleGiftPreMoney) {
				this.$message.error('当前赠送金额不足！')
				return false
			}
			const h = this.$createElement
			const that = this
			this.$msgbox({
				title: '确认扣减？',
				message: h('div', null, [
					h('div', { style: 'padding-left:20px;font-size: 14px' }, `本次扣减本金￥${+that.decreasePercentValue}元${that.showgift === 1 ? `,扣减赠送金额￥${+that.decreaseGiftMoney}元` : ''}`),
					h('div', { style: 'padding-left:20px;color: red;' }, '扣减后不可取消或修改')
				]),
				showCancelButton: true,
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let params = {
					money: +this.decreasePercentValue,
					giftMoney: +this.decreaseGiftMoney,
					customerid: this.decreaseRow.customerid,
					prepaymenttype: 7,
					remarks: this.remarks
				}
				let changeData = {
					pre: { decreaseDetail: {} },
					cur: { decreaseDetail: { decreasePercentValue: +this.decreasePercentValue, decreaseGiftMoney: +this.decreaseGiftMoney, remarks: this.remarks } }
				}
				const logger = this.$fxLogger.createInfo('payCenter.pay-advance.update', changeData)
				this.$store.dispatch('requestPost', {
					url: `${this.$fxBaseApi.urlQIVShop}/order/prepayment/add`,
					data: params,
					logger
				}).then(res => {
					if (res.result) {
						this.decreasePercentValue = ''
						this.decreaseGiftMoney = ''
						this.decreaseDialogVisible = false
						this.$message.success('扣减成功！')
						this.$emit('modifySuc')
					} else {
						if (res.msg === null) {
							this.$message.error('处理失败，请稍后重试！')
						} else {
							this.$message.error(res.msg)
						}
					}
				})
			})
		}
	}
}
</script>

<style lang="stylus" scoped>
.main-table {
	display flex
	flex: 1
	flex-direction: column
	min-height: 0
	.main-table-box {
		flex: 1
		width: 100%
		// padding-bottom 10px
		box-sizing: border-box;
		overflow: hidden
		overflow-y: auto;
		display flex
		flex-direction: column
	}
	.over-hidden{
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
	}
	.history-status {
		display: flex;
		justify-content: center;
		align-items: center;
		span {
			display: inline-block;
			width: 6px;
			height: 6px;
			background: #60C769;
			border-radius: 50%;
			margin-right: 10px;
		}
	}
	.page-box {
		height: 32px;
		position: relative
		.sum-box {
			position: absolute
			left: 60px;
			top: 50%;
			transform: translateY(-50%);
			font-size: 14px;
			display: flex;
			align-items: center;
			.sum-tip {
				flex-shrink: 0;
				cursor: pointer;
				margin-left:6px
			}
		}
	}
}
.preview-box {
	width: 100%;
	text-align: center;
	margin: 10px 0;
	img {
		display: inline-block
	}
}
</style>
<style lang="stylus">
.sum-pop {
	padding: 10px 25px 10px 20px;
	.sum-popcontent{
		line-height: 25px;
		display: flex
		&>div:not(:last-of-type) {
			margin-right: 50px
		}
	}
}
.main-table {
	.tip-modal {
		margin-top: 20vh
	}
	.el-dialog {
		border-radius: 4px
	}
	.el-dialog__title {
		padding-left 10px
		border-left 5px solid var(--fx-primary-color)
	}
	.el-dialog__body {
		padding-top: 10px
	}
	.dialog-title {
		text-align: left
		.el-dialog__headerbtn{
			width: 20px;
			height: 20px;
			border-radius: 50%;
			background-color: red;
			line-height: 20px;
			font-weight:blod;
			.el-icon-close{
				color:#fff
			}
		}
	}
	.el-radio-group {
		display flex
		flex-direction: column
		padding: 0 15px 20px
		.el-radio {
			line-height: 30px
		}
	}
	.dialog-charge-content {
		color: #333;
		&>div {
			margin-bottom: 15px;
			display: flex;
			align-items: center;
		}
		.dialog-name {
			display: inline-block;
			width: 100px;
			text-align: right;
			margin-right: 10px;
			flex-shrink: 0
		}
		.dialog-readonly {
			width: 263px;
			height: 32px;
			line-height: 32px;
			text-indent: 10px;
			background: #F2F2F2;
			border: 1px solid #DBDBDB;
			border-radius: 4px;
		}
		.per-money {
			position: relative
			margin-right: 5px;
			.per-tag {
				position: absolute
				left: 1px
				top: 1px
				bottom: 1px;
				width: 40px;
				z-index: 9;
				display: flex;
				border-top-left-radius: 4px;
				border-bottom-left-radius: 4px;
				align-items: center;
				justify-content: center;
				background-color: #eee;
			}
			.per-input {
				width: 265px
				input {
					text-indent: 35px
				}
			}
		}
	}
}
</style>
